/** @jsx jsx */
import { type SerializedStyles, jsx } from '@emotion/react';

import * as React from 'react';

import config from 'js/app/config';

import { TrackedA } from 'bundles/page/components/TrackedLink2';
import LinkTag from 'bundles/seo/components/LinkTag';

type Props = {
  skill: string;
  cssOverrides?: SerializedStyles;
};

export const SeoSkillsLinkTag = ({ skill, cssOverrides }: Props) => {
  const encodedSkill = encodeURIComponent(skill.toLowerCase());
  const href = `${config.url.base}courses?query=${encodedSkill}`;

  return (
    <span css={cssOverrides}>
      <LinkTag href={href} component={TrackedA} trackingName="seo_skills_link_tag" data={{ skill }}>
        {skill}
      </LinkTag>
    </span>
  );
};

export default SeoSkillsLinkTag;
